import HelloSign from 'hellosign-embedded'
/**
 * This function provides all the hellosign API information needed to open the hellosign Iframe modal
 * @param {object} hs
 * @param {function} listener
 * @param {string} claimUrl
 */
export const openEsignModal = (hs, event, listener, claimUrl) => {
  const client = new HelloSign();
  client.on(event, listener)
  client.open(claimUrl, {
    clientId: hs.clientId,
    skipDomainVerification: hs.testMode
  })
}
